"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;
var React = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("../../utils");
var _dateRangePicker = require("../../utils/date-range-picker");
var _Text = require("../Text");
var _Day = require("./Day");
var _CalendarModule = _interopRequireDefault(require("./Calendar.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// $FlowFixMe[untyped-import]

const getFormattedDate = (marker, dateRange) => {
  const {
    startDate,
    endDate
  } = dateRange;
  switch (marker) {
    case _utils.MARKERS.DATE_RANGE_START:
      return startDate ? _moment.default.utc(startDate).format('MMMM D, YYYY') : 'Start Date';
    default:
      return endDate ? _moment.default.utc(endDate).format('MMMM D, YYYY') : 'End Date';
  }
};
const Calendar = _ref => {
  let {
    value,
    marker,
    minDate,
    maxDate = (0, _utils.formatIsoDate)(),
    handlers,
    hoverDay,
    dateRange,
    inHoverRange,
    today
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: _CalendarModule.default.calendar
  }, /*#__PURE__*/React.createElement(_Text.SubTitleExtraSmall, {
    className: _CalendarModule.default.selectedDate,
    color: _Text.TEXT_COLORS.secondary
  }, getFormattedDate(marker, dateRange)), /*#__PURE__*/React.createElement("div", {
    className: _CalendarModule.default.calendarRow
  }, _utils.WEEKDAYS.map(day => /*#__PURE__*/React.createElement(_Text.BodySmall, {
    key: day,
    className: _CalendarModule.default.calendarRowItem,
    color: _Text.TEXT_COLORS.tertiary
  }, day))), (0, _utils.getDaysInMonth)(value).map((week, index) => /*#__PURE__*/React.createElement("div", {
    key: week[index],
    className: _CalendarModule.default.calendarRow
  }, week.map(date => {
    const isRangeValid = (0, _utils.isStartDateEndDateSame)(dateRange);
    const isStart = (0, _utils.isStartOfRange)(dateRange, date);
    const isEnd = (0, _utils.isEndOfRange)(dateRange, date);
    const highlighted = (0, _utils.inDateRange)(dateRange, date) || inHoverRange(date);
    const {
      onDayClick,
      onDayHover
    } = handlers;
    const dateValue = _moment.default.utc(date);
    return /*#__PURE__*/React.createElement(_Day.Day, {
      key: date,
      date: date,
      filled: isStart || isEnd,
      onClick: () => onDayClick(date),
      onHover: () => onDayHover(date),
      outlined: (0, _dateRangePicker.isSame)(date, today, 'd'),
      disabled: minDate && (0, _dateRangePicker.isBefore)(date, minDate) || (0, _dateRangePicker.isAfter)(date, maxDate) || !(0, _dateRangePicker.isSame)(date, value, 'month'),
      endOfRange: isEnd && !isRangeValid,
      highlighted: highlighted && !isRangeValid,
      startOfRange: isStart && !isRangeValid,
      value: dateValue.date(),
      hoverDay: hoverDay
    });
  }))));
};
exports.Calendar = Calendar;